/** 
*@author: satyamurthy.a
*@Description : 
**/
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Input, message, Button, Tooltip } from 'antd';
import { connect } from 'react-redux';
import localStorage from '../../../utils/localStorage';
import styles from '../../../commons/styles';
import { API_AUTH } from '../../../commons/api';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const { StyledWrapper, StyledWrapperLeft, StyledWrapperRight } = styles.layout;

const ChangePassword = (props) => {
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [passwordCriteria, setPasswordCriteria] = useState({
    length: false,
    number: false,
    uppercase: false,
    lowercase: false,
    specialChar: false,
    common: false,
    consecutive: false
  });

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);

  const handleFocus = (event) => {
    event.target.setAttribute('autocomplete', 'off');
  };

  const validatePassword = (password) => {
    const criteria = {
      length: password.length >= 8 && password.length <= 13,
      number: /\d/.test(password),
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      specialChar: /[!@#$%^&*]/.test(password),
      common: /password|123456|qwerty/i.test(password),
      consecutive: /(.)\1{2,}/.test(password)
    };

    setPasswordCriteria(criteria);
    return criteria;
  };

  const renderPasswordChecklist = () => {
    const criteriaList = [
      { text: translation('8-13 characters'), valid: passwordCriteria.length },
      { text: translation('At least one number'), valid: passwordCriteria.number },
      { text: translation('At least one uppercase letter'), valid: passwordCriteria.uppercase },
      { text: translation('At least one lowercase letter'), valid: passwordCriteria.lowercase },
      { text: translation('At least one special character'), valid: passwordCriteria.specialChar },
      { text: translation('Not a common password'), valid: !passwordCriteria.common },
      {
        text: translation('No consecutive identical characters'),
        valid: !passwordCriteria.consecutive
      }
    ];

    return (
      <ul>
        {criteriaList.map((criterion, index) => (
          <li key={index}>
            {criterion.valid ? (
              <span style={{ color: 'green' }}>
                <CheckCircleOutlined />
              </span>
            ) : (
              <span style={{ color: 'red' }}>
                <CloseCircleOutlined />
              </span>
            )}
            {criterion.text}
          </li>
        ))}
      </ul>
    );
  };

  const changePasswordAPI = (values) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const changePassword = {
      method: 'POST',
      url: `${API_AUTH.ChangePassword}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: { ...values, SiteId: siteId }
    };

    axios(changePassword)
      .then((response) => {
        message.success(response.data.message);
        localStorage.set('accessToken', 'null');
        props.navigate('/login');
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          message.error(error.response.data.message);
        } else {
          message.error(translation('An error occurred. Please try again.'));
        }
      });
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const onFinish = (values) => {
    const passwordError = validatePassword(values.password);
    if (
      !passwordError.length ||
      !passwordError.number ||
      !passwordError.uppercase ||
      !passwordError.lowercase ||
      !passwordError.specialChar ||
      passwordError.common ||
      passwordError.consecutive
    ) {
      message.error(translation('Password does not meet the requirements.'));
      return;
    }

    if (values.password !== values.confirmPassword) {
      message.error(translation('Passwords do not match.'));
      return;
    }

    changePasswordAPI(values);
  };

  const onFinishFailed = () => {};

  return (
    <div>
      <StyledWrapper>
        <StyledWrapperLeft>
          <div>{translation('Change Password')}</div>
          {translation(
            'After a successful password update, you will be redirected to the login page where you can log in with your new password.'
          )}
        </StyledWrapperLeft>
        <StyledWrapperRight style={{ width: '70%' }}>
          <Form
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off">
            <Form.Item
              label={translation('Old Password')}
              name="oldPassword"
              rules={[
                {
                  required: true,
                  message: translation('Please input your old password')
                }
              ]}>
              <Input.Password
                style={{ width: '300px' }}
                placeholder={translation('Input your old password')}
                onFocus={handleFocus}
              />
            </Form.Item>
            <Tooltip placement="bottom" title={<div>{renderPasswordChecklist()}</div>}>
              <div>
              <Form.Item
                label={translation('New Password')}
                name="password"
                rules={[
                  {
                    required: true,
                    message: translation('Please input your new password')
                  }
                ]}>
                <Input.Password
                  style={{ width: '300px' }}
                  placeholder={translation('Input your new password')}
                  onFocus={handleFocus}
                  onChange={(e) => {
                    validatePassword(e.target.value);
                  }}
                />
              </Form.Item>
              </div>
            </Tooltip>

            <Tooltip placement="bottom" title={<div>{renderPasswordChecklist()}</div>}>
              <div>
              <Form.Item
                label={translation('Confirm New Password')}
                name="confirmPassword"
                rules={[
                  {
                    required: true,
                    message: translation('Please input your confirm new password')
                  }
                ]}>
                <Input.Password
                  style={{ width: '300px' }}
                  placeholder={translation('Confirm your new password')}
                  onFocus={handleFocus}
                />
              </Form.Item>
              </div>
            </Tooltip>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <Button type="primary" htmlType="submit">
                {translation('Save')}
              </Button>
            </Form.Item>
          </Form>
        </StyledWrapperRight>
      </StyledWrapper>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(ChangePassword);
